export default __webpack_public_path__ + "static/media/Mole.0fd6d92d.png";